<template>
  <section id="kelas-iklim">
    <Header :scrolled="true"/>
    <div class="loading" v-if="loading"></div>
    <div class="pageInfo bumiKini" v-else>
      <div class="pageInfoWrapper">
        <div class="photosHeader">
          <div class="backBtn" v-on:click="$router.go(-1)"></div>
          <h4>Galeri Foto</h4>
        </div>

        <div class="photoAlbumCnt">
          <div class="images" v-viewer="options">
            <div class="imgCnt" v-for="p in photos" :key="p.id">
              <img :src="p.media.imageSm" :data-src="p.media.imageLg"
                class="image">
              <div class="caption" v-if="p.caption && p.caption !== ''">{{p.caption}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="snackbar" v-if="snackbar">{{snackbar}}</div>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';

export default {
  name: 'home',
  components: { Header },
  data() {
    return {
      containerId: 'qwe',
      snackbar: null,
      loading: true,
      photos: [],
      options: {
        url: 'data-src',
        title: false,
        movable: false,
        zoomOnWheel: false,
        slideOnTouch: true,
      },
    };
  },
  methods: {
    dowloadVideo(type) {
      this.openDowloadOption = false;
      if (type === 'potrait') {
        window.open('https://drive.google.com/file/d/14RTJREyXRO3EnRGVGLElK-ohzal-3iNi/view');
      } else {
        window.open('https://drive.google.com/file/d/136h62N1gIBz61hA93YrZAUhVM59xg3Xx/view');
      }
    },
    copy(text) {
      this.copyTextToClipboard(text);
    },
    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;

      // Avoid scrolling to bottom
      textArea.style.top = '0';
      textArea.style.left = '0';
      textArea.style.position = 'fixed';

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand('copy');
        if (successful) {
          this.snackbar = `${text} copied to clipboard.`;
          setTimeout(() => {
            this.snackbar = null;
          }, 1600);
        }
      } catch (err) { err.message(); }

      document.body.removeChild(textArea);
    },
    copyTextToClipboard(text) {
      if (!navigator.clipboard) {
        this.fallbackCopyTextToClipboard(text);
        return;
      }
      navigator.clipboard.writeText(text).then(() => {
        this.snackbar = `${text} copied to clipboard.`;
        setTimeout(() => {
          this.snackbar = null;
        }, 1600);
      });
    },
  },
  computed: {
    video() {
      return this.$refs.video.player;
    },
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = 'Mengabarkan Kita Tenggelam - Bumi Butuh Aksi';
    const { uri } = this.$route.params;
    this.$http.get(this.$config.uri(`photographer/photos/${uri}`)).then((r) => {
      this.photos = (r.data.status === 200) ? r.data.data.photos : [];
      this.loading = false;
    });
  },
};
</script>


<style scoped lang="scss">
  .theVideo{
    box-shadow: 4px 4px 0 #31c1f4;
  }
  .snackbar{
    position: fixed;
    bottom: 10px;
    left: 50%;
    background-color: rgba(0,0,0,.8);
    color: #fff;
    padding: 10px 20px;
    z-index: 999;
    border-radius: 6px;
    transform: translateX(-50%);
    @media (max-width: 680px) {
      left: 30px; right: 30px;
      transform: none;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .loading{
    height: 100vh;
    background-image: url(../assets/loading-2.svg);
    background-size: 54px auto;
    background-position: center;
    background-repeat: no-repeat;
  }
  .pageInfo{
    // background-image: url(../assets/kelas-iklim.jpg);
    background-size: cover;
    background-position: center;
    position: relative;
    margin-top: 71px;
    @media (max-width: 760px) {
      margin-top: 62px;
    }
    &:before{
      content: ""; display: block;
      position: absolute;
      top: 0; right: 0; left: 0; bottom: 0;
      background-image: linear-gradient(rgba(255, 255, 255, .5), #fff);
    }
    .pageInfoWrapper{
      position: relative;
      z-index: 2;
      margin: 0 auto -120px;
      padding: 20px 0 160px;
      // text-align: center;
      .photosHeader{
        max-width: 1200px;
        margin: 0 auto 30px;
        position: relative;
        padding-left: 60px;
        box-sizing: border-box;
        .backBtn{
          width: 36px; height: 36px;
          background-color: #eee;
          border-radius: 50%;
          background-image: url(../assets/left-arrow.png);
          background-position: center;
          background-size: 20px auto;
          background-repeat: no-repeat;
          cursor: pointer;
          position: absolute;
          left: 0; top: 0;
          &:hover{
            background-color: #ddd;
          }
        }
        h4{
          margin: 0 0 20px;
        }
      }
      .coverImg{
        width: 100%;
        height: auto;
        margin: -20px auto 30px;
        max-width: 1200px;
        display: block;
        @media (max-width: 1360px){
          margin-top: -20px;
        }
        @media (max-width: 990px){
          margin: -40px -20px 30px;
          width: calc(100% + 40px);
        }
        @media (max-width: 760px){
          margin-top: -30px;
        }
      }
      .worCnt{
        max-width: 800px;
        margin: 0 auto;
        > ol > li{
          margin-bottom: 40px;
        }
      }
      iframe{
        width: 100%;
        height: 440px;
        @media (max-width: 768px) {
          height: 400px;
        }
        @media (max-width: 680px) {
          height: 180px;
        }
      }
      h2{
        max-width: 800px;
        margin: 0 auto 20px;
        font-size: 46px;
      }
      h4{
        margin: 40px auto 16px;
        font-size: 24px;
        max-width: 800px;
        line-height: 1.5;
      }
      p{
        margin: 0 auto 16px;
        max-width: 800px;
        font-size: 20px;
        line-height: 1.5;
        @media (max-width: 680px) {
          font-size: 19px;
          line-height: 1.4;
        }
      }
      a{
        color: #0b9a6b;
        text-decoration: none;
        font-weight: bold;
        &:hover{
          color: #32c1f4;
        }
        &.copy-hashtag{
          display: inline-block;
          padding-right: 30px;
          position: relative;
          // background-color: #eee;
          border-radius: 50px;
          padding-left: 6px;
          &:before{
            content: "";
            display: block;
            position: absolute;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            right: 0; top: 0;
            background-image: url(../assets/copy.png);
            background-size: 18px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          &:hover{
            background-color: #f9f9f9;
            &:before{
              background-image: url(../assets/copy-hover.png);
            }
          }
          &:active{
            background-color: #eee;
          }
        }
        &.ext-link{
          display: inline-block;
          padding-right: 30px;
          position: relative;
          // background-color: #eee;
          border-radius: 50px;
          padding-left: 6px;
          &:before{
            content: "";
            display: block;
            position: absolute;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            right: 0; top: 0;
            background-image: url(../assets/external-link.png);
            background-size: 18px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          &:hover{
            background-color: #f9f9f9;
            &:before{
              background-image: url(../assets/external-link-hover.png);
            }
          }
          &:active{
            background-color: #eee;
          }
        }
      }
      a.btn{
        color: #fff;
        margin-bottom: 20px;
        &:hover{
          color: #fff;
        }
      }
      ol{
        margin: 0;
        padding: 0;
        padding-left: 24px;
        font-size: 20px;
        &.a{
          list-style: lower-alpha;
        }
        li{
          margin: 0 0 10px;
        }
        h5{
          margin: 0 0 10px;
          font-size: 20px;
          font-weight: bold;
          line-height: 1.5;
        }
      }
      .photoAlbumCnt{
        max-width: 1200px;
        margin: 0 auto;
        .images{
          display: flex;
          flex-wrap: wrap;
          margin: 0 -7px;
          .imgCnt{
            width: calc(33.3333% - 14px);
            margin: 0 7px 14px;
            background-color: #fff;
            @media (max-width: 680px) {
              width: calc(100% - 14px);
              border: none;
            }
            img{
              width: 100%;
              cursor: pointer;
            }
            .caption{
              font-size: 12px;
              line-height: 1.2;
              color: #767676;
            }
          }
        }
      }
      .photoAlbum{
        display: flex;
        flex-wrap: wrap;
        margin: 0 -10px;
        .photoItem{
          margin-bottom: 40px;
          width: calc(33.3333% - 22px);
          margin: 0 10px 20px;
          background-color: #fff;
          border: #eee 1px solid;
          box-shadow: border-box;
          // border-left: #eee 1px solid;
          // box-shadow: 2px 2px 2px rgba(0,0,0,.1);
          @media (max-width: 680px) {
            width: calc(100% - 20px);
            border: none;
          }
          .thePhoto{
            height: 240px;
            background-position: center;
            background-size: cover;
            margin: 5px;
            @media (max-width: 980px) {
              height: 160px;
            }
            @media (max-width: 680px) {
              height: 210px;
              margin: 0;
            }
          }
          .caption{
            font-size: 13px;
            line-height: 1.2;
            padding: 5px 14px 16px;
            color: #767676;
            @media (max-width: 680px) {
              padding: 7px 0 0 5px;
            }
          }
        }
      }

      .qwe{
        max-width: 800px;
        margin: 0 auto;
        .profile{
          padding-left: 150px;
          position: relative;
          min-height: 120px;
          padding-bottom: 40px;
          border-top: #eee 1px solid;
          margin-top: 50px;
          padding-top: 20px;
          .profilePict{
            position: absolute;
            width: 120px; height: 120px;
            border-radius: 50%;
            top: 26px; left: 0;
            background-color: #eee;
            background-position: center;
            background-size: cover;
          }
          h4{
            margin: 0;
          }
          .qweInfo{
            white-space: pre-line;
          }
        }
        .viewMorePhoto{
          color: #0b835c;
          font-weight: bold;
          border: #0b835c 1px solid;
          display: inline-block;
          padding: 10px 20px;
          cursor: pointer;
          transition: all .3s ease;
          &:hover{
            background-color: #0b835c;
            color: #fff;
          }
        }
      }

      @media (max-width: 760px) {
        padding-top: 30px;
        .coverImg{
          margin-top: -30px;
        }
        h2{
          font-size: 50px;
          margin-left: -3px;
        }
        h4{
          font-size: 22px;
        }
      }
    }
  }
</style>
